import React from "react";
import "./Skeleton.css";

function Skeleton({ className, ...props }) {
  return (
    <div
      className={`animate-pulse rounded-md bg-muted ${className}`} 
      {...props}
    />
  );
}

export { Skeleton };